module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAAJhJREFUKBV9koERgzAIRTOCo3QBd8so2aTdQBfRLtC7+Oj5Y2yg/w4RwhPkkmqtD+yJTemPbnUEL8y0YC5I3j78xkw58Ziw1SI0gOR6oLRhOHDBEBDpgDM5jXR1ECD/A36ITTHQgdZBwMa7uxzV21L6n96JTcNyIqBQ7C4nBHQQghz0IxUB8i5IUjdiAAKw3YisgsifHb91ByT9WYZbTW3jAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloseChat.png
// module id = 50
// module chunks = 0